// Minimal SW registration
export function registerServiceWorker() {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then(() => {
        // eslint-disable-next-line no-console
        console.log("[SW] registered");
      })
      .catch((e) => {
        // eslint-disable-next-line no-console
        console.warn("[SW] registration failed:", e);
      });
  });
}
